import { useEffect } from "react"

export function useChunkErrorHandler() {
  useEffect(() => {
    const handleChunkError = (event: ErrorEvent) => {
      const { message, filename } = event

      const isChunkLoadError =
        message?.includes("Loading chunk") ||
        message?.includes("Failed to fetch dynamically imported module") ||
        message?.includes("Loading CSS chunk") ||
        filename?.includes("/assets/")

      if (isChunkLoadError) {
        console.warn("🔄 Chunk load error detected, attempting to reload...", { message, filename })

        setTimeout(() => {
          window.location.reload()
        }, 100)
      }
    }

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      const error = event.reason

      if (
        error?.message?.includes("Failed to fetch dynamically imported module") ||
        error?.message?.includes("Loading chunk")
      ) {
        console.warn("🔄 Dynamic import error detected, attempting to reload...", error)

        event.preventDefault()

        setTimeout(() => {
          window.location.reload()
        }, 100)
      }
    }

    window.addEventListener("error", handleChunkError)
    window.addEventListener("unhandledrejection", handleUnhandledRejection)

    return () => {
      window.removeEventListener("error", handleChunkError)
      window.removeEventListener("unhandledrejection", handleUnhandledRejection)
    }
  }, [])
}
